module.exports = __webpack_public_path__ + "static/Oracletester2-a77324201565f1cc1225c848b790330c.png";